<div class="label">
    <ng-content select="[label]"></ng-content>
    <div class="required-label">&nbsp;{{isRequired ? '*' : ''}}</div>
</div>
<div [ngClass]="(type !== 'textarea') ? 'custom-input' : '' " #inputEl>
    <!-- backend validation message -->
    <span
        [ngClass]="type == 'date' || type == 'time'  ? (type == 'time' ? 'form-error-icon-time' : 'form-error-icon-date') : 'form-error-icon'"
        *ngIf="ngControl.errors?.length" [ngbTooltip]="ngControl.errors?.length ? errorTooltip : null" #t="ngbTooltip"
        triggers="manual" (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" tooltipClass="apc-tooltip-top"
        placement="top" triggers="hover">
        <img src="assets/ico/error-solid.svg" alt="error">
    </span>
    <ng-template #errorTooltip>
        <span *ngFor="let error of ngControl.errors">
            {{error.message}} <br />
        </span>
    </ng-template>

    <!-- generic input type -->
    <input *ngIf='type !== "textarea" && type != "date" && !isCurrency && !disabled' [class]="class" [type]="type"
        [placeholder]="placeholder" [(ngModel)]="value" [ngModelOptions]="{standalone: true}" [disabled]="disabled"
        (input)="onChange()" (change)="onChange()" (blur)="onTouchedFn()" (mouseover)="showErrorTooltip()"
        (focus)="onFocus()" (mouseout)="t?.close()" [readonly]="isEdit" (keypress)="decimalWithComma($event)" />
    <span class="disabledInputSpan" *ngIf='type !== "textarea" && type != "date" && !isCurrency && disabled && value'>{{value}}</span>
    <span class="disabledInputSpan" *ngIf='type !== "textarea" && type != "date" && !isCurrency && disabled && !value'>&nbsp;</span>

    <!-- if input is currency -->
    <input *ngIf='isCurrency && !disabled' [class]="class" [placeholder]="placeholder" [(ngModel)]="value" [disabled]="disabled"
        (ngModelChange)="onChange()" (input)="onChange()" (change)="onChange()" (blur)="onTouchedFn()"
        (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" currencyMask
        [options]="options"
        (focus)="onFocus()" [readonly]="isEdit" />
    <span class="disabledInputSpan" *ngIf='isCurrency && disabled && value'>{{value}}&nbsp;€</span>
    <span class="disabledInputSpan" *ngIf='isCurrency && disabled && !value'>&nbsp;</span>

    <!-- generic input type -->
    <div class="position-relative">
        <!-- if view mode instead of date type show text type su value can be copy pasted -->
        <input *ngIf='type == "date" && !isCurrency && dateType == "text" && !disabled' [class]="class" [value]="computedPlaceolder"
            type="text" (mouseenter)="handleDateInputEdit()" (mouseleave)="setInputTypeDate()" [readonly]="!isEdit" />
        <input *ngIf='type == "date" && !isCurrency  && dateType == "date" && !disabled' [class]="class"
            [placeholder]="computedPlaceolder" [(ngModel)]="value" [ngModelOptions]="{standalone: true}"
            [disabled]="disabled" (input)="onChange()" (change)="onChange()" (blur)="onTouchedFn()"
            [ngClass]="{'apc-date apc-date-placeholder': (type === 'date' && onEdit === false)}" max="2999-12-31"
            (mouseover)="showErrorTooltip()" (mouseout)="t?.close()" [type]="dateType"
            (mouseenter)="handleDateInputEdit()" (mouseleave)="setInputTypeDate()" />
        <!-- input date cleaner -->
        <span *ngIf='type === "date" && value && !disabled' class="ng-clear-wrapper" title="Clear all">
            <span aria-hidden="true" class="ng-clear" type="button" (click)="clearDate()">
                ×
            </span>
        </span>
        <span class="disabledInputSpan" *ngIf='type == "date" && !isCurrency && dateType == "text" && disabled && value' type="text">{{value}}</span>
        <span class="disabledInputSpan" *ngIf='type == "date" && !isCurrency && dateType == "text" && disabled && !value' type="text">&nbsp;</span>
        <span class="disabledInputSpan" *ngIf='type == "date" && !isCurrency && dateType == "date" && disabled && value' type="date">{{value | date: 'dd/MM/yyyy' }}</span>
        <span class="disabledInputSpan" *ngIf='type == "date" && !isCurrency && dateType == "date" && disabled && !value' type="date">&nbsp;</span>
    </div>

    <!-- input type textarea -->
    <textarea *ngIf='type === "textarea" && !disabled' [class]="class" [placeholder]="placeholder" [(ngModel)]="value"
        [ngModelOptions]="{standalone: true}" [disabled]="disabled" [rows]="rows" (input)="onChange()"
        (change)="onChange()" (blur)="onTouchedFn()" (mouseover)="showErrorTooltip()" (mouseout)="t?.close()"
        (focus)="onFocus()" [readonly]="isEdit">
    </textarea>
    <span class="disabledInputSpan" *ngIf='type === "textarea" && disabled && value'>{{value}}</span>
    <span class="disabledInputSpan" *ngIf='type === "textarea" && disabled && !value'>&nbsp;</span>

</div>